<template>
  <div v-if="visible" class="find-photos">
    <div class="find-photos__phone">
      <img :src="phoneMockup" alt=""/>
    </div>

    <div class="find-photos__body">
      <div class="find-photos__top">
        <div class="find-photos__head">
          <span v-translate translate-context="login.photos" class="find-photos__label">Your event photos</span>
          <button type="button" class="find-photos__close" @click="close"
                  :aria-label="$pgettext('login.photos', 'Close')">
            <CIcon name="cip-close" size="custom-size" :width="16" :height="16"/>
          </button>
        </div>
        <p v-translate translate-context="login.photos" class="find-photos__text">Did you attend an event and are now looking for your photos?</p>
      </div>

      <a href="https://www.getpica.com" target="_blank" rel="noopener noreferrer" class="find-photos__cta">
        <span v-translate translate-context="login.photos">Go to getpica.com</span>
        <CIcon name="cip-arrow-narrow-up-right" size="custom-size" :width="14" :height="14"/>
      </a>
    </div>
  </div>
</template>

<script>
import phoneMockup from '@/assets/images/login/phone-mockup.png'

export default {
  name: 'FindYourPhotos',
  data() {
    return {
      visible: true,
      phoneMockup
    }
  },
  methods: {
    close() {
      this.visible = false
    }
  }
}
</script>

